import styled from '@emotion/styled';
import type { Survey } from '@hotjar/feedback/domain/Surveys/Survey/Survey';
import { tokens, TextInput, Textarea, Field, Stack } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const NAME_MAX_LENGTH = 50;

export const DESCRIPTION_MAX_LENGTH = 500;

const Container = styled(Stack)`
  /* override insights styles 
  TODO: remove when legacy styles are deprecated */
  label {
    text-transform: none;
  }
  /* end overrides */
`;

const InputFieldContainer = styled(Field)`
  /* override insights styles 
  TODO: remove when legacy styles are deprecated */
  input {
    height: ${tokens.spacer.x5} !important;
    font-size: 14px !important;
    padding: 0 ${tokens.spacer.x2} !important;
  }
  /* end overrides */
`;

const DisplayInputWrapper = styled.div`
  ${tokens.text('body2')}
  color: ${tokens.color.text_light};
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`;

const StyledTextInput = styled(TextInput)`
  width: 280px;
`;

const StyledTextarea = styled(Textarea)`
  width: 424px;
`;

export interface DetailsSectionProps {
  name: Survey['name'];
  description: string | undefined | null;
  showErrors: boolean;
  onNameChanged: (newName: string) => void;
  onDescriptionChanged: (newDescription: string) => void;
}

export const DetailsSection = ({
  name,
  description,
  showErrors,
  onNameChanged,
  onDescriptionChanged,
}: DetailsSectionProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  const isNameValid = name !== undefined && name !== null && name.length > 0;

  return (
    <Container spacing="x5" direction="column">
      <DisplayInputWrapper>
        <InputFieldContainer
          labelText={t('wizard.section.details.name-label')}
          inputId="name"
          invalidText={t('wizard.section.details.name-error')}
          isRequired
          isInvalid={showErrors && !isNameValid}
        >
          <StyledTextInput
            id="name"
            name="name"
            placeholder={t('wizard.section.details.name-placeholder')}
            maxLength={NAME_MAX_LENGTH}
            value={name ?? ''}
            onChange={(e) => onNameChanged(e.target.value)}
            isInvalid={showErrors && !isNameValid}
            isRequired
          />
        </InputFieldContainer>
      </DisplayInputWrapper>
      <DisplayInputWrapper>
        <InputFieldContainer
          inputId="description"
          labelText={t('wizard.section.details.description-label')}
        >
          <StyledTextarea
            id="description"
            name="description"
            placeholder={t('wizard.section.details.description-placeholder')}
            rows={4}
            value={description ?? ''}
            onChange={(e) => onDescriptionChanged(e.target.value)}
            maxLength={DESCRIPTION_MAX_LENGTH}
          />
        </InputFieldContainer>
      </DisplayInputWrapper>
    </Container>
  );
};
